import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ShowSidebar from "../Sidebar/ShowSidebar";
import { Helmet } from "react-helmet";
import {
  getShowAwards,
  getShowDetailPage,
} from "../../../utils/api/helpers/show";
import { S3URL } from "../../../data/globalConstants";
import ShowAwardsList from "./components/ShowAwardsList";
gsap.registerPlugin(ScrollTrigger);
import { useActiveGenre } from "../../../utils/Genre/activeGenreState";

export default function ShowAwardsDetail() {
  const { genreSlug, showSlug } = useParams();
  const [activeGenre] = useActiveGenre();

  const [showData, setShowData] = useState(null);
  const [showAwards, setShowAwards] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!genreSlug) return;

    setIsLoading(true);

    getShowDetailPage(genreSlug, showSlug)
      .then((res) => {
        // console.log("RES SHOW", res.data);
        setShowData(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [genreSlug]);

  useEffect(() => {
    getShowAwards(genreSlug, showSlug).then((res) => {
      if (res.data.competitions.length > 0) {
        setShowAwards(res.data.competitions);
      }
    });
  }, [genreSlug, showSlug]);

  if (isLoading) {
    return (
      <div className="loading-message-container">
        <div className="loading-message">
          <img
            src="/img/ico/spinner.gif"
            alt="Loading..."
            className="loading-spinner"
          />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Helmet>
          <title>{`${showData?.title} | FYC`}</title>
          <meta name="description" content={`${showData?.title}`} />
        </Helmet>

        <div
          className="width-ctrl show-page-container"
          style={{ paddingTop: "120px" }}
        >
          <div className="show-page-inner">
            <div className="show-left-column">
              <ShowSidebar
                showData={showData}
                genreSlug={genreSlug}
                showSlug={showSlug}
                displayAwards={false}
              />
            </div>
            <div className="show-right-column">
              <div className="show-main-content">
                <div className="show-awards-page-content">
                  <div
                    className="award-page-title"
                    style={{ color: activeGenre?.theme?.colors?.light?.hex }}
                  >
                    Nominations and Wins
                  </div>
                  <ShowAwardsList showAwards={showAwards} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="show-page-background">
          <img
            src={S3URL + showData?.backgroundImage}
            loading="lazy"
            alt={showData?.title}
            className="show-masked-image blurred-image"
          />
        </div>
      </div>
    );
  }
}
